import { useRequest } from 'ahooks';
import { getDevicePoints, MeasurementType } from '@/api/history';
import dayjs from 'dayjs';
import { TrendGranularity } from '../types';
import { formatRequestTime } from '../utils';
import {
  apiV2EnvMonitorDashboardDeviceDetailPost,
  V2EnvMonitorDashboardDeviceDetailPostResponse,
} from '@maxtropy/device-customer-apis-v2';

export type DeviceDetailData = V2EnvMonitorDashboardDeviceDetailPostResponse;

export type DeviceDetailDataPoint = Exclude<DeviceDetailData['chartData'], undefined>[number];

const GRANULARITY_MAP: Record<TrendGranularity, string> = {
  [TrendGranularity.HOUR]: 'H',
  [TrendGranularity.DAY]: 'D',
  [TrendGranularity.MONTH]: 'M',
};

export const useDevicePoints = (deviceId?: number, refreshKey?: number) =>
  useRequest(() => getDevicePoints(deviceId!).then(res => res.list ?? []), {
    ready: !!deviceId,
    refreshDeps: [deviceId, refreshKey],
  });

export const useDeviceDetail = (
  deviceId: number,
  propertyId: number | null,
  measurementType: MeasurementType,
  granularity: TrendGranularity,
  dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null,
  refreshKey: number
) => {
  const gran = GRANULARITY_MAP[granularity];

  return useRequest(
    async () => {
      if (!deviceId || !propertyId || !dateRange?.[0] || !dateRange?.[1]) return undefined;
      const { startTime, endTime } = formatRequestTime(dateRange, granularity);
      return await apiV2EnvMonitorDashboardDeviceDetailPost({
        deviceId,
        propertyId,
        measurementType,
        granularity: gran,
        startTime,
        endTime,
      });
    },
    {
      ready: !!deviceId && !!propertyId && !!dateRange?.[0] && !!dateRange?.[1],
      refreshDeps: [deviceId, propertyId, measurementType, granularity, dateRange, refreshKey],
    }
  );
};
